export const products = [
  {
    id: 1,
    name: "Dashcam Basic HD",
    description: "Kamerë me cilësi të lartë HD për regjistrim të qartë të rrugës. Ideale për përdorim ditor.",
    features: ["HD 1080p", "Regjistrimi i natës", "G-Sensor", "Loop Recording"],
    oldPrice: 4990,
    price: 2990,
    image: "/cam1.png",
    inStock: true,
    badge: "Ofertë e re"
  },
  {
    id: 2,
    name: "Dashcam Dual Camera Set",
    description: "Set kompleti me kamerë përpara dhe prapa. Mbulim 360° për siguri maksimale.",
    features: ["Dual Camera", "4K Resolution", "Wi-Fi Connected", "Parking Mode"],
    oldPrice: 6990,
    price: 4490,
    image: "/cam2.png",
    inStock: true,
    badge: "Më i shituri"
  },
  {
    id: 3,
    name: "Dashcam Premium Dual 4K",
    description: "Model premium me kamerë dyfishe dhe ekran të madh. Cilësi 4K për regjistrime kristal.",
    features: ["4K Ultra HD", "Dual Camera", "LCD Screen 3''", "Night Vision"],
    oldPrice: 6990,
    price: 5590,
    image: "/cam3.png",
    inStock: true,
    badge: "Premium"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Arben M.",
    location: "Tiranë",
    rating: 5,
    text: "Shërbim i shkëlqyer! Dashcam-i punon perfekt dhe më ka shpëtuar nga një aksident. Rekomandoj 100%!",
    date: "2 javë më parë"
  },
  {
    id: 2,
    name: "Elona K.",
    location: "Durrës",
    rating: 5,
    text: "Cilësi e lartë dhe çmim i arsyeshëm. Instalimi ishte shumë i lehtë. Faleminderit!",
    date: "1 muaj më parë"
  },
  {
    id: 3,
    name: "Gentian S.",
    location: "Prishtinë",
    rating: 5,
    text: "Dërgesa e shpejtë në Kosovë. Produkti është saktësisht si në përshkrim. Ju lumtë!",
    date: "3 javë më parë"
  },
  {
    id: 4,
    name: "Alma B.",
    location: "Shkup",
    rating: 5,
    text: "E rekomandoj për të gjithë! Kamera punon perfekt edhe natën. Shërbim profesional!",
    date: "2 muaj më parë"
  }
];

export const faqs = [
  {
    id: 1,
    question: "Si mund të bëj porosi?",
    answer: "Për të bërë porosi, na dërgoni një mesazh direkt (DM) në Instagram @dashcam.store.albania me produktin që dëshironi dhe adresën tuaj të dërgesës. Ne do t'ju kontaktojmë menjëherë për detaje."
  },
  {
    id: 2,
    question: "Cilat janë kohët e dërgesës?",
    answer: "Dërgesë në të gjithë Shqipërinë brenda 1-2 ditëve. Për Kosovë dhe Maqedoni, 2-4 ditë. Dërgesa është falas për porosi mbi 5,000 lekë."
  },
  {
    id: 3,
    question: "A keni garanci për produktet?",
    answer: "Po! Të gjitha produktet vijnë me garanci 12 mujore. Nëse keni ndonjë problem, na kontaktoni dhe do ta zgjidhim menjëherë."
  },
  {
    id: 4,
    question: "Si funksionon instalimi i dashcam-it?",
    answer: "Instalimi është shumë i thjeshtë. Çdo produkt vjen me udhëzime të detajuara. Gjithashtu, ofrojmë mbështetje falas për instalim përmes mesazheve."
  },
  {
    id: 5,
    question: "A mund të kthej produktin nëse nuk jam i kënaqur?",
    answer: "Po, keni 14 ditë për të kthyer produktin nëse nuk jeni plotësisht të kënaqur. Produkti duhet të jetë në gjendje origjinale."
  },
  {
    id: 6,
    question: "Cilat metoda pagese pranoni?",
    answer: "Pranojmë pagesë në dorëzim (cash on delivery) për Shqipëri. Për porosi ndërkombëtare, pranojmë transferta bankare."
  }
];

export const features = [
  {
    id: 1,
    title: "Cilësi e Lartë",
    description: "Produkte të përzgjedhura me kujdes nga brendet më të mira në treg. Garanci cilësie për çdo produkt.",
    icon: "shield-check"
  },
  {
    id: 2,
    title: "Çmime të Arsyeshme",
    description: "Ofertat më të mira në treg. Zbritje të rregullta dhe oferta speciale për klientët tanë besnikë.",
    icon: "tag"
  },
  {
    id: 3,
    title: "Dërgesa e Shpejtë",
    description: "Dërgojmë në të gjithë Shqipërinë, Kosovën dhe Maqedoninë. Shërbim i shpejtë dhe i sigurt.",
    icon: "truck"
  },
  {
    id: 4,
    title: "Mbështetje 24/7",
    description: "Ekipi ynë është gjithmonë gati për t'ju ndihmuar. Kontaktoni në Instagram për çdo pyetje.",
    icon: "headphones"
  }
];

export const stats = [
  {
    id: 1,
    value: "500+",
    label: "Klientë të Kënaqur"
  },
  {
    id: 2,
    value: "1000+",
    label: "Produkte të Shitura"
  },
  {
    id: 3,
    value: "3",
    label: "Vende Dërgese"
  },
  {
    id: 4,
    value: "12",
    label: "Muaj Garanci"
  }
];
